export default __webpack_public_path__ + "static/media/icon-gearinactive.3430a8c4.svg";